import React from "react";
import { Collapse } from "../../ui/collapse";
import { TextBox } from "../text-box";
import { Input } from "../../ui/input";
import { useUI } from "../../context";
import { Select } from "../../ui/select";

const Row = ({ children }) => (
  <div className="flex-1 flex flex-col lg:flex-row gap-4">{children}</div>
);

export const Step4 = (props) => {
  const {
    page_settings: { step4 },
  } = useUI();

  return (
    <>
      <TextBox title={step4.title} />
      <div className="flex flex-col gap-4">
        <Row>
          <Input
            name={step4.fieldName}
            placeholder={step4.labelFieldName}
            register={props.register}
            isError={!!props.errors[step4.fieldName]}
          />
          <Input
            name={step4.fieldFirstName}
            placeholder={step4.labelFieldFirstName}
            register={props.register}
            isError={!!props.errors[step4.fieldFirstName]}
          />
        </Row>
        <Row>
          <Input
            name={step4.fieldPhoneNumber}
            placeholder={step4.labelFieldPhoneNumber}
            register={props.register}
            isError={!!props.errors[step4.fieldPhoneNumber]}
          />
          <Select
            name={step4.fieldLanguage}
            register={props.register}
            isError={!!props.errors[step4.fieldLanguage]}
          >
            {step4.variantsFieldLanguage.map((item, index) => (
              <option key={index} value={item.value}>
                {item.title}
              </option>
            ))}
          </Select>
        </Row>
        <Row>
          <Input
            name={step4.fieldEmail}
            placeholder={step4.labelFieldEmail}
            register={props.register}
            isError={!!props.errors[step4.fieldEmail]}
            type="email"
          />
          <Input
            name={step4.fieldAddress}
            placeholder={step4.labelFieldAddress}
            register={props.register}
            isError={!!props.errors[step4.fieldAddress]}
          />
        </Row>
        {step4.terms.map((item, index) => (
          <Collapse key={index} {...item} />
        ))}
      </div>
    </>
  );
};
